import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";

import moving from "../../assets/images/moving.jpg";
import fewItems from "../../assets/images/TII/Two-Movers-With-Box-On-Stairca-97352312.jpg";
import apartments from "../../assets/images/TII/0d29cde6ea92435fc56819d5d1f3d55a.jpg";
import office from "../../assets/images/MOF/half.jpg";
import clip from "../../assets/images/magal/clip.mp4";
import "./Transport.css";

const Transport = () => {
  const [start, setStart] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (start && location.hash !== '#top') {
      document.querySelector(".homeTitle").scrollIntoView();
      setStart(false);
    }
  }, [location, start]);

  const servicesArr = [
    {
      header: "פריטים בודדים",
      img: fewItems,
      link: "/transportfewitems",
    },
    {
      header: "דירות ובתים",
      img: apartments,
      link: "/transportapartment",
    },
    {
      header: "משרדים/מפעלים",
      img: office,
      link: "/transportoffice",
    },
  ];

  return (
    <div className="transport">
      <div className="page_banner">
        <img src={moving} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הובלה</h1>
            <p>שירות בכל רחבי הארץ באמינות ודיוק ללא פשרות</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="פריטים בודדים" link="/transportfewitems" />
            <MainBtn
              text="דירות ובתים"
              link="/transportapartment#top"
              isLight={true}
            />
            <MainBtn text="משרדים/מפעלים" link="/transportoffice" />
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">בחרו את סוג ההובלה שלכם</h1>
        <div className="services three">
          {servicesArr.map((el, i) => {
            return (
              <Link to={el.link} key={i}>
                <div className="service">
                  <img src={el.img} alt="" />
                  <h4>{el.header}</h4>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="about">
        <h1 className="homeTitle">אודותינו</h1>
        <div className="clipWrapper">
          <video
            className="clip"
            playsInline
            src={clip}
            autoPlay={true}
            muted={true}
            controls
          />
        </div>
      </div>

      <Reviews />
      <Footer isContact={true} />
    </div>
  );
};

export default Transport;
